import React from 'react';
const VideoComponent = ({
  src,
  videoPlaybackSpeed
}: {
  src: string;
  videoPlaybackSpeed?: number;
}) => {
  const setPlaybackSpeed = videoRef => {
    if (!videoRef || !videoPlaybackSpeed) {
      return;
    }
    videoRef.defaultPlaybackRate = videoPlaybackSpeed;
    videoRef.playbackRate = videoPlaybackSpeed;
  };
  return <video controls controlsList="nodownload" style={{
    maxWidth: '100%'
  }} ref={setPlaybackSpeed}>
      <source src={src} />
      This video type is not supported: {src}
    </video>;
};
export default VideoComponent;